import Recto from './Recto';

const RectoContainer = Recto;

RectoContainer.defaultAnswer = () => undefined;

RectoContainer.validationSchema = () => undefined;

export default RectoContainer;
